import React,{ PureComponent } from 'react'
import {Select,Empty} from 'antd';
import PropTypes from 'prop-types';
import Lang from "@components/Lang/Lang";
import SearchFromService from "../../../../../components/SearchForm/SearchFrom.action";
import "./index.less"
const { Option } = Select;

/**
 * 物流 搜索 下拉
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 *
 **/
export default class LogisticsSelect extends PureComponent{
    static propTypes = {
        api: PropTypes.string.isRequired,
        onChange: PropTypes.func,
        nameField:  PropTypes.any,
        idField: PropTypes.string,
    }
    static defaultProps = {
        api:'',
        nameField:'name',
        idField:'id',
        type:"",
        list:[],
        recommendLogisticsInfo:{}
    };
    constructor(props){
        super(props)
        this.state = {
            loading:false,
            items:[]
        }
    }
    /**
     * 搜索
     * @param api 查询的接口
     */
    onInitFetch() {
        const { api, list} = this.props;
        if(api){
            SearchFromService.fetch(api,{}).then((resp)=>this.showInitResult(resp.data));
        }else {
            const data = {
                models:list,
                success:true,
                valid:true
            }
            this.showInitResult(data)
        }
    }
    /**
     * 赋值处理
     */
    showInitResult = (result={}) =>{
        if(result.success&&result.valid){
            let models = result.models || [];
            const {idField,nameField} = this.props;
            models.forEach(item=>{
                item["id"] = item[idField];
                item["name"] = item[nameField];
            })
            this.setState({
                items: models
            })
        }
    }
    /**
     * 单独搜索
     *
     **/
    singleSearch(data,){
        // let { currSearch={} }= this.state;
        // currSearch[key] = data;
        // this.setState({
        //     currSearch : currSearch
        // })
        this.props.onChange(data);
        if(this.props.onOtherChange)this.props.onOtherChange(data);
    }
    /**
     * 输出select
     * */
    getOptions(list=[],type){
        const enumChildren = [];
        list.forEach(item=>{
            // const iconUrl = type=="abbreviate"&&item.abbreviate?require('../../assets/img/country/'+item.abbreviate + '.png'):"";
            enumChildren.push(<Option key={item.id} value={item.id}>
                {/*{iconUrl?<img src={iconUrl.default} height={10.5} className={"mr_8"} />:null}*/}
                {item.name}</Option>)
        });
        return enumChildren;
    }
    // 修改
    change(value,option={}){
        this.props.onChange(option.obj)
    }
    componentDidMount(){
        this.onInitFetch();
        if( this.props.onRef)this.props.onRef(this);
    }
    render() {
        const {list,recommendLogisticsInfo, } = this.props;
        return (<><Select allowClear placeholder={Lang({id:"QingXuanZeWuLiuGongSi", default:"请选择物流公司"})}
                          value={[]}
                          notFoundContent={ <Empty description={Lang({id: 'MeiYouGaiChengShiShiPeiDeWuLiu',default:'没有该城市适配的物流'})} />}
                        onChange={(value,option )=>this.change(value,option)} >
            {list.length>0?list.map((children,clKey)=>{return(<Option key={clKey}
                                                                        id={children.id}
                                                                        obj={children}
                                                                        value={children.id}>
                    <p>{children.name}</p>
                    <p>{children.remark}</p>
            </Option>)}):null}
        </Select>
        {/* 已推荐公司*/}
        {recommendLogisticsInfo.name&&<div className={"recommendLogsWrap mt_16 mb_16"}>
            <p className={"fw_700 font_16 black89 fw_500"}>{recommendLogisticsInfo.name}</p>
            {recommendLogisticsInfo.contactList&&recommendLogisticsInfo.contactList.length>0&&recommendLogisticsInfo.contactList.map((con,inx)=><div className={"black45 mt_4"} key={"con_"+inx}>
                <span className={"black89 mr_8"}>{con.name}</span>+<span>{con.telCode}</span><span className={"ml_4"}>{con.mobile}</span>
            </div>)}
        </div>}
        </>)
    }
}
